<template>
	<svg
		class="shrink-0"
		viewBox="0 0 20 20"
		fill="none"
		aria-hidden="true"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M20 10C20 15.4902 15.4902 20 10 20C4.5098 20 0 15.4902 0 10C0 4.5098 4.5098 0 10 0C15.4902 0 20 4.5098 20 10ZM6.47059 10C6.47059 8.82353 5.4902 7.84314 4.31373 7.84314C3.13725 7.84314 2.15686 8.82353 2.15686 10C2.15686 11.1765 3.13725 12.1569 4.31373 12.1569C5.4902 12.1569 6.47059 11.1765 6.47059 10ZM12.2549 10C12.2549 8.82353 11.2745 7.84314 10.098 7.84314C8.92157 7.84314 7.94118 8.82353 7.94118 10C7.94118 11.1765 8.92157 12.1569 10.098 12.1569C11.2745 12.1569 12.2549 11.1765 12.2549 10ZM17.9412 10C17.9412 8.82353 16.9608 7.84314 15.7843 7.84314C14.6078 7.84314 13.6274 8.82353 13.6274 10C13.6274 11.1765 14.6078 12.1569 15.7843 12.1569C16.3725 12.1569 16.9608 11.9608 17.3529 11.4706C17.7451 11.0784 18.0392 10.4902 18.0392 9.90196L17.9412 10Z"
			fill="currentColor"
		/>
	</svg>
</template>
